// Memórias da IA sobre a empresa (preferências, ideias rejeitadas, aprendizados), com remover.
import { useState } from 'react'
import { Brain, Trash2 } from 'lucide-react'
import { dateBR } from '@impulso/shared'
import type { ContextFactDto } from '@impulso/shared/api/ai'
import { errorMessage } from '../../lib/api'
import { ErrorState, Loading } from '../../ui'
import { useAddFact, useFacts, useRemoveFact } from './api'

const KIND: Record<ContextFactDto['kind'], string> = { preference: 'Preferência', rejection: 'Não quis', learning: 'Aprendizado', answer: 'Resposta' }
const SOURCE: Record<ContextFactDto['source'], string> = { user: 'você anotou', chat: 'dito no assistente', feedback: 'ideia recusada', system: 'resultados' }

export default function FactsCard({ companyId, canEdit }: { companyId: string; canEdit: boolean }) {
  const q = useFacts(companyId)
  const add = useAddFact(companyId)
  const remove = useRemoveFact(companyId)
  const [text, setText] = useState('')
  const items = q.data?.items ?? []

  return (
    <section className="card">
      <div className="card-head">
        <span className="ic purple"><Brain size={18} /></span>
        <div>
          <h3>O que a IA já sabe sobre você</h3>
          <p className="small muted">Preferências e recusas que a IA leva em conta. Remova o que não vale mais.</p>
        </div>
      </div>
      {q.isLoading && <Loading lines={2} />}
      {q.error && <ErrorState error={q.error} onRetry={() => q.refetch()} />}
      {q.data && items.length === 0 && <p className="muted small">Nenhuma memória ainda. Ela aparece quando você diz uma preferência no assistente ou recusa uma ideia.</p>}
      {items.length > 0 && (
        <div className="list">
          {items.map((f) => (
            <div key={f.id} className="list-item">
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ overflowWrap: 'anywhere' }}>{f.text}</div>
                <div className="small muted">{KIND[f.kind]} · {SOURCE[f.source]} · {dateBR(f.createdAt)}</div>
              </div>
              {canEdit && (
                <button className="icon-btn" aria-label="Remover memória" disabled={remove.isPending} onClick={() => remove.mutate(f.id)}><Trash2 size={16} /></button>
              )}
            </div>
          ))}
        </div>
      )}
      {canEdit && (
        <form className="row mt-12" style={{ gap: 8 }} onSubmit={(e) => { e.preventDefault(); if (text.trim().length >= 3) add.mutate(text.trim(), { onSuccess: () => setText('') }) }}>
          <input className="input" style={{ flex: 1, minWidth: 0 }} value={text} maxLength={300} placeholder="Ex.: Prefiro textos sem emojis" aria-label="Nova memória" onChange={(e) => setText(e.target.value)} />
          <button className="btn" disabled={add.isPending || text.trim().length < 3}>Anotar</button>
        </form>
      )}
      {(add.error || remove.error) && <div className="form-error mt-8">{errorMessage(add.error ?? remove.error)}</div>}
    </section>
  )
}
